/**
 * @param  {String} value HeaderValue
 * @param  {Object} con Configuration Object
 * @param  {Number} con.f Flex Value
 * @param  {Number} con.mw Max Width. No need to provide Max Width for ordinary Columns. For Icon Columns the Width should be 30, 40, or 50 (Based on Size)
 * @param  {Number} con.minw Minimum Width, Rarely needed. Might be needed for naturally large Columns
 * @param  {Number} con.text Pass in Custom String for Custom Text. text: false to Hide the Column Text
 * @param  {Number} con.ta Text Align Value
 * @param  {Number} con.fw Font Weight
 * @param  {String} c Color Value
 */
export const createTableHeader = (value = '', {
  f = undefined,
  mw = undefined,
  minw = undefined,
  text = undefined,
  ta = undefined,
  fw = undefined,
  c = undefined,
} = {}) => {
  if (text === '') {
    throw Error('Pass in "text: false" instead of Empty String in createTableHeader for clarity');
  }
  if (text === false) {
    text = '';
  }

  return {
    text,
    f,
    mw,
    minw,
    value,
    ta,
    fw,
    c,
  };
};

/**
 * @param  {Number} headerHeight=28 Caution: Usually Not needed. Very specific use case. Always Rowheight is the Headerheight
 * @param  {Number} rowHeight=40 Row Height of the Table
 * @param  {Number} headerStyle=1 Specifies one of 3 Header Styles
 * @param  {Number} scrollNextThreshold=70 The Threshold After which the Next Scroll Event will be emitted
 * @param  {Boolean} fullHeight=false Most cases this should be True
 * @param  {Boolean} footer=false Footer Flag. Will show the Footer Template if the value is true
 * @param  {Boolean} showHeader=true Will Show the Header
 */
export const createNTableConfig = ({
  headerHeight,
  rowHeight = 32,
  key = 'index',
  headerStyle = 1,
  scrollNextThreshold = 90,
  fullHeight = false,
  footer = false,
  showHeader = true,
  autoRowVisibleCount = 50,
} = {}) => {
  if (!headerHeight) {
    headerHeight = rowHeight;
  }

  return {
    headerHeight,
    rowHeight,
    key,
    headerStyle,
    scrollNextThreshold,
    rowHeight,
    fullHeight,
    footer,
    showHeader,
    autoRowVisibleCount,
  };
}


export const TableStylePropTypes = {
  height: {
    type: String,
  },
  thpad: {
    type: String,
  },
  tdpad: {
    type: String,
  },
  thspad: {
    type: String,
  },
  thsmar: {
    type: String,
  },
  tdbdr: {
    type: String,
  },
  bb: {
    type: String,
  },
}

window.createTableHeader=createTableHeader;
window.createNTableConfig=createNTableConfig;